import { formatLocationOption } from "../../utils/Chloromance/utils/plants";

type ZoneToolbarProps = {
  activeZones: string[];
  selectedZone: string;
  undoWateringLabel: string;
  onSelectZone: (zone: string) => void;
  onMassWaterZone: (zone: string) => void;
  onUndoWatering: () => void;
};

export function ZoneToolbar({
  activeZones,
  selectedZone,
  undoWateringLabel,
  onSelectZone,
  onMassWaterZone,
  onUndoWatering,
}: ZoneToolbarProps) {
  return (
    <section className="zone-toolbar" aria-label="Location filters and batch watering">
      <div className="zone-tabs">
        {['All Locations', ...activeZones].map((zone) => (
          <button key={zone} className={selectedZone === zone ? 'is-active' : ''} type="button" onClick={() => onSelectZone(zone)}>
            {zone === 'All Locations' ? zone : formatLocationOption(zone)}
          </button>
        ))}
      </div>
      <div className="mass-water-controls">
        {activeZones.map((zone) => (
          <button key={zone} type="button" onClick={() => onMassWaterZone(zone)}>Water {formatLocationOption(zone)}</button>
        ))}
      </div>
      {undoWateringLabel && (
        <div className="undo-water-row">
          <button className="undo-water-button" type="button" onClick={onUndoWatering}>
            {undoWateringLabel}
          </button>
        </div>
      )}
    </section>
  );
}
